import { render } from "./TaykusChat.vue?vue&type=template&id=155b155d"
import script from "./TaykusChat.vue?vue&type=script&lang=js"
export * from "./TaykusChat.vue?vue&type=script&lang=js"

import "./TaykusChat.vue?vue&type=style&index=0&id=155b155d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__